export enum ERibbonColors {
    DANGER = 'danger',
    NONE = '',
    WARNING = 'warning',
}
